import { toJalaali, toGregorian, jalaaliMonthLength } from "jalaali-js";

export const monthLen = (jy, jm) => jalaaliMonthLength(jy, jm);

export const MONTHS = ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"];
export const WEEKDAYS = ["شنبه", "یکشنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنجشنبه", "جمعه"];

export const fa = (n) => Number(n).toLocaleString("fa-IR", { useGrouping: false });
export const faMoney = (n) => (n === null || n === undefined || n === "" ? "—" : Number(n).toLocaleString("fa-IR"));
export const p2 = (n) => String(n).padStart(2, "0");

export const todayIso = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Tehran" }).format(new Date());

// هر مقدار تاریخ (YYYY-MM-DD یا ISO با ساعت) را به YYYY-MM-DD به وقت تهران تبدیل می‌کند
export const normIso = (v) => {
  const s = String(v ?? "");
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const d = new Date(s.replace(" ", "T"));
  if (Number.isNaN(d.getTime())) return s.slice(0, 10);
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Tehran" }).format(d);
};

export const isoToJ = (iso) => {
  const [gy, gm, gd] = normIso(iso).split("-").map(Number);
  return toJalaali(gy, gm, gd);
};
export const jToIso = (jy, jm, jd) => {
  const g = toGregorian(jy, jm, jd);
  return `${g.gy}-${p2(g.gm)}-${p2(g.gd)}`;
};
export const todayJ = () => isoToJ(todayIso());

export const formatDate = (iso) => {
  if (!iso) return "—";
  const j = isoToJ(iso);
  return `${fa(j.jy)}/${fa(p2(j.jm))}/${fa(p2(j.jd))}`;
};
export const formatLongDate = (iso) => {
  const j = isoToJ(iso);
  const wd = new Date(`${iso}T12:00:00Z`).getUTCDay(); // 0=یکشنبه
  const names = ["یکشنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنجشنبه", "جمعه", "شنبه"];
  return `${names[wd]} ${fa(j.jd)} ${MONTHS[j.jm - 1]} ${fa(j.jy)}`;
};

/** بازه‌ی ISO یک ماه شمسی */
export const monthRange = (jy, jm) => ({
  from: jToIso(jy, jm, 1),
  to: jToIso(jy, jm, jalaaliMonthLength(jy, jm)),
});

/** تعداد روز + ایندکس شروع هفته (شنبه=۰) برای ماه شمسی */
export const monthGrid = (jy, jm) => {
  const first = jToIso(jy, jm, 1);
  const wd = new Date(`${first}T12:00:00Z`).getUTCDay(); // یکشنبه=۰
  return { days: jalaaliMonthLength(jy, jm), offset: (wd + 1) % 7 };
};

export const initials = (name) => String(name || "?").trim().split(/\s+/).map((s) => s[0]).slice(0, 2).join("‌");
